import { ref, computed } from 'vue';
import i18n from '@/i18n';
import { supportedLocales } from '@/i18n';

// 全局语言状态
const currentLocale = ref(localStorage.getItem('locale') || 'zh');

// 获取当前语言
export const getCurrentLocale = () => currentLocale.value;

// 获取当前语言名称
export const getCurrentLanguageName = () => {
  const current = supportedLocales.find(l => l.code === currentLocale.value);
  return current ? current.name : '简体中文';
};

// 切换语言
export const changeLanguage = (langCode) => {
  if (i18n.global.locale.value !== langCode) {
    i18n.global.locale.value = langCode;
    currentLocale.value = langCode;
    localStorage.setItem('locale', langCode);
    
    // 设置文档方向（阿拉伯语从右到左）
    if (langCode === 'ar') {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = langCode;
    }
    
    return true;
  }
  return false;
};

// 获取支持的语言列表
export const getSupportedLocales = () => supportedLocales;

// 检查是否为RTL语言
export const isRTL = () => currentLocale.value === 'ar';

// 响应式的当前语言
export const useCurrentLocale = () => {
  return computed(() => currentLocale.value);
};

// 响应式的当前语言名称
export const useCurrentLanguageName = () => {
  return computed(() => getCurrentLanguageName());
};

// 响应式的RTL状态
export const useIsRTL = () => {
  return computed(() => isRTL());
};
